import type { ProductRoutingResponse } from "@halm-club/halm-shared";
import "./styles.css";

declare global {
  interface Window {
    isUserInABTestGroup?: (testName: string) => boolean;
    pdpRedirectUrl?: string;
  }
}

const AB_TEST_NAME = "PROBLEM_SOLVER_TEST";
const ROUTING_TIMEOUT_MS = 5_000;
const PRODUCT_ROUTING_ENDPOINT =
  "https://api.halm.club/api/v2/shopify/product-routing";

const redirectToLegacyPdp = () => {
  window.location.replace(window.pdpRedirectUrl || "/");
};

const getProductRedirectUrl = async () => {
  const params = new URLSearchParams(window.location.search);
  params.delete("view");

  const controller = new AbortController();
  const timeout = window.setTimeout(
    () => controller.abort(),
    ROUTING_TIMEOUT_MS,
  );

  try {
    const response = await fetch(
      `${PRODUCT_ROUTING_ENDPOINT}?${params.toString()}`,
      { signal: controller.signal },
    );

    if (!response.ok) {
      throw new Error(`Product routing failed with status ${response.status}`);
    }

    const data = (await response.json()) as ProductRoutingResponse;
    const redirectUrl = new URL(data.redirectUrl, window.location.origin);

    if (
      redirectUrl.origin !== window.location.origin ||
      !redirectUrl.pathname.startsWith("/products/")
    ) {
      throw new Error("Product routing returned an invalid redirect URL");
    }

    return `${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}`;
  } finally {
    window.clearTimeout(timeout);
  }
};

const routeCustomer = async () => {
  if (!window.isUserInABTestGroup?.(AB_TEST_NAME)) {
    redirectToLegacyPdp();
    return;
  }

  try {
    window.location.replace(await getProductRedirectUrl());
  } catch (error) {
    console.error("Could not resolve product route", error);
    redirectToLegacyPdp();
  }
};

void routeCustomer();
